module.exports = __webpack_public_path__ + "static/media/previous_round.ae282d84.webp";